module.exports = __webpack_public_path__ + "static/media/filter-icon.f032c444.webp";